var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-item-group-two',{attrs:{"no-action":"","sub-group":"","item":_vm.item}})
}
var staticRenderFns = []

export { render, staticRenderFns }